var animationFlag = false;

    var hideCollapse;
    var buttonIcon;

    if (window.innerWidth > 1024){
        hideCollapse = '#hide-collapse-';
        buttonIcon = "#buttonIcon-";
    }else{
        hideCollapse = '#hide-collapseMobile-';
        buttonIcon = "#buttonIconMobile-";
    }

    function clickCollapseItem(e, id ,flag) {

        if (animationFlag) {
            return;
        }
        animationFlag = true;

        // 显示或隐藏文本 与  旋转加号
        if ($(hideCollapse + id + "-" + flag).css('display') === 'none') {
            $(buttonIcon + id + "-" + flag + " svg").css('transform', 'rotate(180deg)');
            $(hideCollapse + id + "-" + flag).slideDown(function () {
                animationFlag = false;
            })
        } else {
            $(buttonIcon + id + "-" + flag + " svg").css('transform', 'rotate(0deg)');
            $(hideCollapse + id + "-" + flag).slideUp(function () {
                animationFlag = false;
            });
        }

    }